module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "button-bar"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.newAudit
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Audit")]), _vm._v(" "), _c('search-widget', {
    on: {
      "submit": _vm.fetchAudits
    },
    model: {
      value: (_vm.searchTerms),
      callback: function($$v) {
        _vm.searchTerms = $$v
      },
      expression: "searchTerms"
    }
  })], 1), _vm._v(" "), _c('table-list', {
    attrs: {
      "records": _vm.audits,
      "fields": _vm.fields,
      "has-edit": "/audits/form/",
      "has-delete": !_vm.$root.isOffline,
      "delete-endpoint": "auditForm/delete"
    },
    on: {
      "modelChange": _vm.fetchAudits
    }
  }), _vm._v(" "), (_vm.$root.isOffline) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v("\n\t\tSince you are offline, only the audits that were recently stored locally will be accessible. In order to access all your audits you need to connect to the internet!\n\t")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-166fad1d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Audits.vue
// module id = 270
// module chunks = 0